import AgentRoleOptions from "utils/AgentStatusOptions/AgentRoleOptions.jsx";
export const computeAllowedRoles = (role) => {
  if (role === "SUPER_ADMIN") return "all";
  if (role === "PF_USER") return ["PF_MERCHANT"];
  if (role === "PF_ADMIN") return ["PF_ADMIN", "PF_USER", "PF_MERCHANT"];
  return ["PF_MERCHANT"];
};

export const getRoleOptions = (userRole) => {
  const options = AgentRoleOptions(computeAllowedRoles(userRole));
  return Array.isArray(options) ? options : [];
};

export const filterRolePermissionList = (roleList, userRole) => {
  if (userRole === "SUPER_ADMIN") {
    return roleList;
  }
  return roleList.filter((role) => role.title !== "SUPER_ADMIN");
};
